<template>
  <v-container fluid background pa-4>
    <v-layout row wrap pa-3 style="background-color:#fff; margin:5px; border-radius:5px;">
      <!-- command box -->
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md4 xs6 px-1>
            <v-autocomplete
              hide-details
              :loading="loading"
              v-model="emp_code"
              :items="Employee_List"
              item-text="name"
              item-value="code"
              :label="$t('employee_code')"
              allow-overflow
              append-icon="search"
              clearable
              required
            />
          </v-flex>
          <v-flex md2 xs6 px-1>
            <v-btn block color="success" @click="todaybutton()">
              <span>{{$t('processor')}}</span>
            </v-btn>
          </v-flex>
          <v-flex xs12 my-5>
            <v-layout row wrap>
              <v-flex lg1 md2 sm2 xs12 class="text-sm-left text-xs-left">
                <v-btn @click="todaybutton()" color="#039BE5" style="color:#fff;">
                  <v-icon dark left color="#fff;">far fa-calendar-check</v-icon>
                  {{$t('Today')}}
                </v-btn>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12 class="text-sm-left text-xs-left">
                <v-btn @click="prevmonth()">
                  <v-icon dark left>keyboard_arrow_left</v-icon>
                  {{$t('LastMount')}}
                </v-btn>
                <v-btn @click="nextmonth()">
                  {{$t('NextMount')}}
                  <v-icon right dark>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="hidden-xs-only" v-if="show">
            <table
              class="table table-bordered coco-sticky-table"
              style="width:100%;border:1px solid ;color:#fff"
            >
              <thead>
                <th colspan="7" style="width:100%;">
                  <span>{{$t('month.'+monthname)}}</span>
                  <span>{{year}}</span>
                </th>
              </thead>
              <thead>
                <th style="width:14.29%;">
                  <p>{{$t('Sunday')}}</p>
                </th>
                <th style="width:14.29%;">
                  <p>{{$t('Monday')}}</p>
                </th>
                <th style="width:14.29%;">
                  <p>{{$t('Tuesday')}}</p>
                </th>
                <th style="width:14.29%;">
                  <p>{{$t('Wednesday')}}</p>
                </th>
                <th style="width:14.29%;">
                  <p>{{$t('Thursday')}}</p>
                </th>
                <th style="width:14.29%;">
                  <p>{{$t('Friday')}}</p>
                </th>
                <th style="width:14.29%;">
                  <p>{{$t('Saturday')}}</p>
                </th>
              </thead>
              <tbody>
                <tr v-for="(week,index) in calendar3" :key="index">
                  <td v-for="(day,j) in week.days" :key="j">
                    <p v-if="Monthformat(day) == month+1" style="color:#000;">{{Dateformat(day)}}</p>

                    <p v-else style="color:#CFD8DC;">{{Dateformat(day)}}</p>
                    <div v-for="(time,k) in time" :key="k">
                      <div
                        v-if="day == time.date && time.processTimeResults != null && time.isProfileHoliday == false"
                      >
                        <tr>
                          <div v-for="(checkin,i) in time.processTimeResults" :key="i">
                            <td style="width:150px;border:none;" v-if="checkin.time_plan != null">
                              <span
                                style="color:#000;"
                                text-xs-left
                              >{{timeformat(checkin.time_plan)}}</span>
                            </td>
                            <td
                              style="width:150px;border:none;"
                              v-if="checkin.time_checkin != null"
                            >
                              <span
                                v-if="checktimeformat(checkin.time_checkin).split('*').length > 1"
                                style="color:red"
                              >{{checktimeformat(checkin.time_checkin).split('*')[0]}}</span>
                              <span
                                v-else
                                style="color:green"
                              >{{checktimeformat(checkin.time_checkin).split('*')[0]}}</span>
                            </td>
                          </div>
                        </tr>
                        <hr />
                        <tr>
                          <td
                            style="width:70%;border:none;"
                            v-if="time.total_absenttime != number && time.total_absenttime != num"
                          >
                            <span style="color:#B71C1C">ขาด(เวลา) {{time.total_absenttime}} นาที</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_absentday != number && time.total_absentday != num"
                          >
                            <span style="color:color:#E53935">ขาด(วัน) {{time.total_absentday}} วัน</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_absenttime_event != number && time.total_absenttime_event != num"
                          >
                            <span style="color:red">ขาดในวันหยุดพิเศษ {{time.total_absentday}} วัน</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_ottime != number && time.total_ottime != num"
                          >
                            <span style="color:green">OT {{time.total_ottime}} ชั่วโมง</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_ottime_event != number && time.total_ottime_event != num"
                          >
                            <span style="color:#009688">OTวันพิเศษ {{time.total_ottime_event}} ชั่วโมง</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_out_before_time != number && time.total_out_before_time != num"
                          >
                            <span style="color:#9C27B0">ออกก่อนเวลา {{time.total_out_before_time}} นาที</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_leavetime != number && time.total_leavetime != num"
                          >
                            <span style="color:#FB8C00">ชั่วโมงที่ลา {{time.total_leavetime}} ชั่วโมง</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_leaveday != number && time.total_leaveday != num"
                          >
                            <span style="color:#E65100">วันที่ลา {{time.total_leaveday}} วัน</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_leavetime_event != number && time.total_leavetime_event != num"
                          >
                            <span style="color:#FF6D00">วันพิเศษที่ลา {{time.total_leavetime_event}} วัน</span>
                          </td>
                          <td
                            style="width:70%;border:none;"
                            v-else-if="time.total_leavetime_uncut != number && time.total_leavetime_uncut != num"
                          >
                            <span
                              style="color:#F4511E"
                            >วันที่ลาไม่หักเงิน {{time.total_leavetime_event}} วัน</span>
                          </td>
                          <td style="width:70%;border:none;" v-else>
                            <span>-</span>
                          </td>
                        </tr>
                      </div>
                      <div v-if="time.processTimeResults == null">
                        <tr
                          style="width:100%;"
                          v-if="day == time.date && time.isProfileHoliday == true"
                        >
                          <div style="text-align:center;background-color:#388E3C;width:100%;">
                            <td>
                              <span>{{Holidayformat(time.from)}}</span>
                            </td>
                          </div>
                        </tr>
                        <tr
                          v-else-if="day == time.date && time.isHoliday == true && time.isProfileHoliday == false"
                        >
                          <div style="text-align:center;background-color:#EF5350;width:100%;">
                            <td style="width:100%;">
                              <span>วันหยุด</span>
                            </td>
                          </div>
                        </tr>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="show">
          <v-layout row wrap class="hidden-sm-and-up">
            <v-flex md12 sm12 xs12 v-for="(item, index) in table_datalist" :key="index" @click="''">
              <v-card class="coco-box-shadow coco-list-hover">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg12 md12 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg10 md10 sm10 xs10 px-5 class="hidden-sm-and-up">
                        <span class="coco-list-label-text content">{{item.code}} :</span>
                        <span>{{item.name}}</span>
                        <br />
                        <span class="coco-list-label-text">
                          {{$t('Department') + ' : '}}
                          <span>{{item.department_name}}</span>
                        </span>
                        <span class="coco-list-label-text">
                          {{$t('Position') + ' : '}}
                          <span>{{item.position}}</span>
                        </span>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2 class="hidden-sm-and-up">
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="cyan lighten-2"
                            icon
                            flat
                            @click="viewcalendar(item.code)"
                          >
                            <v-icon>fas fa-calendar-alt</v-icon>
                          </v-btn>
                          <span>{{$t('view')}}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2 class="hidden-xs-only">
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="cyan lighten-2"
                            icon
                            flat
                            @click="viewcalendar(item.code)"
                          >
                            <v-icon>fas fa-calendar-alt</v-icon>
                          </v-btn>
                          <span>{{$t('view')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12 sm12 xs12 ma-3>
              <template>
                <v-layout wrap row></v-layout>
              </template>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <!-- FormDialog -->
      <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
        {{ snackmsg }}
        <v-btn dark flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog
        v-model="calendarDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>ตารางสแกนนิ้ว</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="calendarDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md4>
                  <v-expansion-panel expand>
                    <v-expansion-panel-content
                      style="background-color:#ffffff;"
                      v-for="(date,i) in head_date"
                      :key="i"
                      expand-icon
                    >
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <v-flex lg1 md1 sm1 xs3 text-xs-center>
                              <v-icon>fa-calendar-alt</v-icon>
                            </v-flex>

                            <v-flex lg9 md9 sm9 xs9>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                  <span>{{selectedformatDate(date)}}</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>
                      <v-card-text>
                        <!-- เพิ่มใหม่ วันที่เริ่มงาน hidden-xs-only content-->
                        <div v-for="(time,j) in time" :key="j">
                          <v-layout
                            row
                            wrap
                            v-if=" date == time.date && time.processTimeResults != null && time.isProfileHoliday == false"
                            style="margin:3px;"
                          >
                            <v-flex xs6>
                              <v-layout
                                row
                                wrap
                                v-for="(checkin,k) in time.processTimeResults"
                                :key="k"
                              >
                                <v-flex xs6>
                                  <v-layout row wrap>
                                    <v-flex xs12 text-xs-center v-if="checkin.time_plan != null">
                                      <span>{{timeformat(checkin.time_plan)}}</span>
                                    </v-flex>
                                    <v-flex xs12 text-xs-center v-else>
                                      <span></span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs6>
                                  <v-layout row wrap>
                                    <v-flex xs12 text-xs-center v-if="checkin.time_checkin != null">
                                      <span
                                        v-if="checktimeformat(checkin.time_checkin).split('*').length > 1"
                                        style="color:red"
                                      >{{checktimeformat(checkin.time_checkin).split('*')[0]}}</span>
                                      <span
                                        v-else
                                        style="color:green"
                                      >{{checktimeformat(checkin.time_checkin).split('*')[0]}}</span>
                                    </v-flex>
                                    <v-flex xs12 text-xs-center v-else>
                                      <span></span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6>
                              <v-layout row wrap>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="time.total_absenttime != number && time.total_absenttime != num"
                                >
                                  <span
                                    style="color:red"
                                  >จำนวนที่ขาด(เวลา) {{time.total_absenttime}} ชั่วโมง</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_absentday != number && time.total_absentday != num"
                                >
                                  <span
                                    style="color:red"
                                  >จำนวนที่ขาด(วัน) {{time.total_absentday}} วัน</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_absenttime_event != number && time.total_absenttime_event != num"
                                >
                                  <span
                                    style="color:red"
                                  >ขาดในวันหยุดพิเศษ {{time.total_absentday}} วัน</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_ottime != number && time.total_ottime != num"
                                >
                                  <span
                                    style="color:red"
                                  >ทำงานล่วงเวลา {{time.total_ottime}} ชั่วโมง</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_ottime_event != number && time.total_ottime_event != num"
                                >
                                  <span
                                    style="color:red"
                                  >ทำงานล่วงเวลาวันพิเศษ {{time.total_ottime_event}} ชั่วโมง</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_out_before_time != number && time.total_out_before_time != num"
                                >
                                  <span
                                    style="color:red"
                                  >ออกก่อนเวลา {{time.total_out_before_time}} นาที</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_leavetime != number && time.total_leavetime != num"
                                >
                                  <span
                                    style="color:red"
                                  >ชั่วโมงที่ลา {{time.total_leavetime}} ชั่วโมง</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_leaveday != number && time.total_leaveday != num"
                                >
                                  <span style="color:red">วันที่ลา {{time.total_leaveday}} วัน</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_leavetime_event != number && time.total_leavetime_event != num"
                                >
                                  <span
                                    style="color:red"
                                  >วันพิเศษที่ลา {{time.total_leavetime_event}} วัน</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-else-if="time.total_leavetime_uncut != number && time.total_leavetime_uncut != num"
                                >
                                  <span
                                    style="color:red"
                                  >วันที่ลาไม่หักเงิน {{time.total_leavetime_uncut}} ชั่วโมง</span>
                                </v-flex>
                                <v-flex xs12 text-xs-center v-else>
                                  <span>-</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            row
                            wrap
                            v-if="time.processTimeResults == null"
                            style="margin:3px;"
                          >
                            <v-flex xs12 v-if="date == time.date && time.isProfileHoliday == true">
                              <v-layout
                                row
                                wrap
                                style="text-align:center;background-color:#C5E1A5;"
                              >
                                <v-flex xs12 text-xs-center>
                                  <span>{{time.from}}</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs12
                              v-else-if="date == time.date && time.isHoliday == true && time.isProfileHoliday == false"
                            >
                              <v-layout
                                row
                                wrap
                                style="text-align:center;background-color:#EF5350;"
                              >
                                <v-flex xs12 text-xs-center>
                                  <span>วันหยุด</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import Utils from "@/utils/";
import moment from "moment";

export default {
  data: () => ({
    table_data: [],
    pageActive: 1,
    snackbarcolor: "red",
    snackbar: false,
    snackmsg: "",
    number: "0.0",
    num: "0",
    snack_type: "",
    responvalue: "",
    delDialogStatus: false,
    calendarDialog: false,
    head_date: [],
    user_datafinger: [],
    time: [],
    table_datalist: [],
    datacheckin: [],
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: ""
    },
    emp_code: "",
    ChoiceSelected: "",
    calendar: [],
    calendar2: [],
    calendar3: [],
    year: moment().get("year"),
    month: moment().get("month"),
    weeks: "",
    startDate: "",
    startWeek: "",
    endWeek: "",
    monthname: "",
    show: false
  }),
  created: function() {
    this.getEmployee("newData");
    this.setShowFilter({ status: 0 });
    this.commitSetToolbar({ patternTool: "1" });
    this.$store.watch(
      state => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
        state.filter.FromDate;
        state.filter.ToDate;
      },
      () => {},
      {
        deep: true
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  computed: {
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate",
      "SearchData"
    ]),
    ...mapState("filter", ["loading", "Employee_List"]),
    ...mapState("app", ["showLoading"]),
    from_date: {
      get() {
        return this.FromDate;
      },
      async set(value) {
        await this.selectedFormDate({ data: value });
      }
    },
    to_date: {
      get() {
        return this.ToDate;
      },
      async set(value) {
        await this.selectedToDate({ data: value });
      }
    }
  },
  methods: {
    ...mapMutations("filter", [
      "setShowFilter",
      "selectedFormDate",
      "selectedToDate",
      "getAllEmployeeByBranch",
      "selectedPosition"
    ]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    ...mapActions("filter", ["getEmployee"]),
    open(event) {
      alert(event.title);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          this.branch_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    process() {
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      console.log("this.emp_code", this.emp_code);
      if (this.emp_code == "") {

        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกพนักงาน";
      } else if (this.emp_code != " ") {
        //this.table_head_model.date = [];

        this.initCalendar();
        this.monthname = months[this.month];
        console.log(this.month);
        this.commitSetShowLoading(true);
        let searchVal = "";
        if (this.SearchData == undefined) {
          searchVal = "";
        } else {
          searchVal = this.SearchData;
        }
        this.commitSetShowLoading(false);
        this.table_datalist == [];
        this.time = [];
        DocumentService.getTimeCheckInByEmp(
          this.startDateOfCalenda,
          this.endDateOfCalenda,
          this.emp_code
        ).then(res => {
          console.log("fff", res);
          this.datacheckin = res.data;
          this.commitSetShowLoading(false);
          this.table_datalist = this.datacheckin;
          console.log(this.table_datalist);
          this.table_datalist.forEach(user_finger => {
            user_finger.processTimes.forEach(element => {
              this.time.push(element);
            });
            //console.log(this.time)
          });
          this.calendar3 = this.calendar2;
        });
      }
    },
    viewcalendar(code) {
      var date = "";
      this.calendarDialog = true;
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = data.add_date;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delDialog.roworder)
        .then(res => {
          this.delDialogStatus = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    
    selectedformatDate(date, format) {
      let v = this;
      var Days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var DaysTH = [
        "อาทิตย์",
        "จันทร์",
        "อังคาร",
        "พูธ",
        "พฤหัสบดี",
        "ศุกร์",
        "เสาร์"
      ];
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var monthsTH = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];
      var d = new Date(date),
        month = "" + d.getMonth(),
        date = "" + d.getDate(),
        days = d.getDay();
      if (localStorage.getItem("lang") == "th") {
        var day = DaysTH[days];
        var m = monthsTH[month];
        var year = d.getFullYear() + 543;
      }
      if (localStorage.getItem("lang") == "en") {
        var m = months[month];
        var day = Days[days];
        var year = d.getFullYear();
      }

      return [day, date, m, year].join(" ");
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    timeformat(date) {
      return moment(date).format("HH:mm");
    },
    checktimeformat(date) {
      let d = [];
      let c = [];
      d = date.split(" ");
      c = d[1].split(":00.0");
      //console.log(c[0]);
      return c[0];
    },
    initCalendar() {
      this.show = true;
      this.calendar = [];
      this.calendar2 = [];
      this.startDate = moment([this.year, this.month]);
      this.startWeek = moment(this.startDate)
        .startOf("month")
        .isoWeek();

      this.endWeek = moment(this.startDate)
        .endOf("month")
        .isoWeek();
      if (this.endWeek < this.startWeek) {
        this.endWeek = this.startWeek + 4;
      }

      console.log(this.startWeek);
      console.log(this.endWeek);
      var i = 1;

      for (
        this.weeks = this.startWeek;
        this.weeks <= this.endWeek + 1;
        this.weeks++
      ) {
        if (i < 7) {
          this.calendar.push({
            week: this.weeks,
            days: Array(7)
              .fill(0)
              .map((n, i) =>
                moment([this.year, this.month])
                  .isoWeek(this.weeks)
                  .startOf("week")
                  .clone()
                  .add(n + i, "day")
                  .format("MM-D-YYYY")
              )
          });
          this.calendar2.push({
            week: this.weeks,
            days: Array(7)
              .fill(0)
              .map((n, i) =>
                moment([this.year, this.month])
                  .isoWeek(this.weeks)
                  .startOf("week")
                  .clone()
                  .add(n + i, "day")
                  .format("YYYY-MM-DD")
              )
          });

          console.log(this.calendar2);
        }
        i = i + 1;
      }
      this.calendar2.forEach(element => {
        element.days.forEach(day => {
          if (this.Monthformat(day) == this.month + 1) {
            this.head_date.push(day);
          }
        });
      });
      var daysInMonth = moment(this.startDate).daysInMonth();

      this.startDateOfCalenda = this.calendar2[0].days[0];
      this.endDateOfCalenda = this.calendar2[5].days[6];

      console.log("start " + this.startDateOfCalenda);
      console.log("end " + this.endDateOfCalenda);
    },
    todaybutton() {
      this.year = moment().get("year"),
      this.month= moment().get("month"),
      this.process();
    },
    prevmonth() {
      if (this.month == 0) {
        this.year = this.year - 1;
        this.month = 11;
      } else {
        this.month = this.month - 1;
      }
      this.process();
    },

    nextmonth() {
      
      if (this.month == 11) {
        this.year = this.year + 1;
        this.month = 0;
      } else {
        this.month = this.month + 1;
      }
      this.process();
    },
    Monthformat(date) {
      return moment(date).format("M");
    },
    Month(month) {
      return moment(date).format("M");
    },
    Dateformat(date) {
      return moment(date).format("DD");
    },
    Holidayformat(holidoy) {
      let value = holidoy.split("Holiday Profile :");
      console.log(value[1]);
      return value[1];
    }
  }
};
</script>
<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
.my-event1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #e908cb;
  color: #ffffff;
  border: 1px solid #e908cb;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
</style>